/* Italian Path — utilidades propias del tema (código propio). */
(function () {
  const EP = (window.EP = window.EP || {});

  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  // Añade un producto al carrito y refresca el carrito lateral de Dawn.
  EP.addToCart = function (variantId, quantity, button) {
    if (!variantId) return Promise.resolve();
    const drawer = cartDrawer();
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    }
    const body = {
      items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }],
    };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((state) => {
        if (state.status) {
          alertFallback(state.description || state.message);
          return;
        }
        if (drawer && state.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: variantId, sections: state.sections });
          setTimeout(function () { EP.syncGift(true); }, 300);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(() => {
        window.location = window.routes.cart_url;
      })
      .finally(() => {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        }
      });
  };

  function alertFallback(message) {
    const box = document.querySelector('.ep-toast') || document.createElement('div');
    box.className = 'ep-toast';
    box.textContent = message || 'No se ha podido añadir el producto.';
    document.body.appendChild(box);
    setTimeout(() => box.remove(), 3500);
  }

  // Botones "Añadir" de upsells (carrito y ficha de producto).
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-ep-add]');
    if (!button) return;
    event.preventDefault();
    EP.addToCart(button.dataset.epAdd, button.dataset.epQty || 1, button);
  });

  // Barra fija de compra en la ficha de producto.
  function initSticky() {
    const bar = document.querySelector('[data-ep-sticky]');
    if (!bar) return;
    const sectionId = bar.dataset.section;
    const anchor =
      document.querySelector('#ProductSubmitButton-' + sectionId) ||
      document.querySelector('product-form button[type="submit"]');
    if (!anchor || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
          bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);

    bar.querySelector('[data-ep-sticky-buy]')?.addEventListener('click', (event) => {
      event.preventDefault();
      const form = document.querySelector('#product-form-' + sectionId);
      const idInput = form && form.querySelector('[name="id"]');
      const qtyInput = document.querySelector('#Quantity-' + sectionId);
      EP.addToCart(idInput ? idInput.value : bar.dataset.variant, qtyInput ? qtyInput.value : 1, event.currentTarget);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSticky);
  } else {
    initSticky();
  }

  // ===== Regalo: Libro de Ejercicios GRATIS al comprar 2 libros (Gramática + Vocabulario) =====
  // Añade o quita solo el Libro de Ejercicios. El precio 0 lo pone el descuento automático
  // «Compra X y llévate Y» de Shopify (Descuentos). Datos en window.EP_GIFT (layout/theme.liquid).
  let giftBusy = false;
  function renderDrawerSilently(drawer, sections) {
    drawer.getSectionsToRender().forEach(function (section) {
      const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!el || !sections[section.id]) return;
      const doc = new DOMParser().parseFromString(sections[section.id], 'text/html');
      const src = doc.querySelector(section.selector || '.shopify-section');
      if (src) el.innerHTML = src.innerHTML;
    });
    const inner = drawer.querySelector('.drawer__inner');
    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
    if (inner) inner.classList.toggle('is-empty', !drawer.querySelector('.cart-item'));
  }
  EP.syncGift = function () {
    const G = window.EP_GIFT;
    if (!G || !G.variant || giftBusy) return Promise.resolve();
    giftBusy = true;
    return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then(function (cart) {
        let units = 0;
        // Si el regalo no sale a 0 € (falta el descuento automático en Shopify), no se añade.
        let off = false;
        try { off = sessionStorage.getItem('epGiftOff') === '1'; } catch (e) {}
        let gift = null;
        let paid = false;
        cart.items.forEach(function (it) {
          if (G.buy.indexOf(it.handle) > -1) units += it.quantity;
          if (it.variant_id === G.variant) {
            if (it.properties && it.properties._regalo) gift = it;
            else paid = true;
          }
        });
        if (gift && gift.final_line_price > 0) {
          try { sessionStorage.setItem('epGiftOff', '1'); } catch (e) {}
          off = true;
        }
        const want = units >= G.min && !paid && !off;
        let url = null;
        let body = null;
        if (want && !gift) {
          url = window.routes.cart_add_url + '.js';
          body = { items: [{ id: G.variant, quantity: 1, properties: { _regalo: 'Libro de Ejercicios GRATIS' } }] };
        } else if (gift && (!want || gift.quantity !== 1)) {
          url = window.routes.cart_change_url + '.js';
          body = { id: gift.key, quantity: want ? 1 : 0 };
        }
        if (!url) return;
        const drawer = cartDrawer();
        if (drawer) {
          body.sections = drawer.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then(function (state) {
            if (!state || state.status) return;
            if (body.items) {
              // Comprobar que el descuento lo ha dejado gratis; si no, se quita en la siguiente pasada.
              giftBusy = false;
              return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
                .then((r) => r.json())
                .then(function (c) {
                  const g = c.items.find(function (it) { return it.variant_id === G.variant && it.properties && it.properties._regalo; });
                  if (g && g.final_line_price > 0) return EP.syncGift();
                  finish(state);
                });
            }
            finish(state);
          });
        function finish(state) {
            if (window.location.pathname.replace(/\/$/, '').endsWith(window.routes.cart_url)) {
              window.location.reload();
              return;
            }
            if (drawer && state.sections) renderDrawerSilently(drawer, state.sections);
        }
      })
      .catch(function () {})
      .finally(function () {
        giftBusy = false;
      });
  };
  function initGift() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'ep-gift') return;
        setTimeout(EP.syncGift, 500);
      });
    }
    EP.syncGift();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGift);
  } else {
    initGift();
  }
})();

